/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ScheduledFrequencyEnum,
    ScheduledFrequencyEnumFromJSON,
    ScheduledFrequencyEnumFromJSONTyped,
    ScheduledFrequencyEnumToJSON,
} from './ScheduledFrequencyEnum';

/**
 * 
 * @export
 * @interface CreatePersonalAssetScheduledDto
 */
export interface CreatePersonalAssetScheduledDto {
    /**
     * 
     * @type {ScheduledFrequencyEnum}
     * @memberof CreatePersonalAssetScheduledDto
     */
    frequency: ScheduledFrequencyEnum | null;
    /**
     * 
     * @type {string}
     * @memberof CreatePersonalAssetScheduledDto
     */
    name: string;
    /**
     * 
     * @type {Date}
     * @memberof CreatePersonalAssetScheduledDto
     */
    startDate: Date;
    /**
     * 
     * @type {Date}
     * @memberof CreatePersonalAssetScheduledDto
     */
    endDate?: Date;
    /**
     * 
     * @type {number}
     * @memberof CreatePersonalAssetScheduledDto
     */
    value: number;
    /**
     * 
     * @type {string}
     * @memberof CreatePersonalAssetScheduledDto
     */
    personalAssetId: string;
}

export function CreatePersonalAssetScheduledDtoFromJSON(json: any): CreatePersonalAssetScheduledDto {
    return CreatePersonalAssetScheduledDtoFromJSONTyped(json, false);
}

export function CreatePersonalAssetScheduledDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreatePersonalAssetScheduledDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'frequency': ScheduledFrequencyEnumFromJSON(json['frequency']),
        'name': json['name'],
        'startDate': (new Date(json['startDate'])),
        'endDate': !exists(json, 'endDate') ? undefined : (new Date(json['endDate'])),
        'value': json['value'],
        'personalAssetId': json['personalAssetId'],
    };
}

export function CreatePersonalAssetScheduledDtoToJSON(value?: CreatePersonalAssetScheduledDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'frequency': ScheduledFrequencyEnumToJSON(value.frequency),
        'name': value.name,
        'startDate': (value.startDate.toISOString()),
        'endDate': value.endDate === undefined ? undefined : (value.endDate.toISOString()),
        'value': value.value,
        'personalAssetId': value.personalAssetId,
    };
}

